

$(document).ready(function() {

    
    // accordion
     var delayIn = 500,
         delayOut = 300,
         $accordionParent = $('.js-blu-accordion-parent'),
         accortionTitleSelector = 'h4';

      $accordionParent.find(accortionTitleSelector).addClass('accordion-title');
      $accordionParent.find(accortionTitleSelector).nextUntil(accortionTitleSelector+',hr').addClass('accordion-cont');
      $('.accordion-title').next('.accordion-cont').addClass('first-after-title');
      $('.accordion-title').prev('.accordion-cont').addClass('last-before-title');
      $('.accordion-title:eq(0)').addClass('first-of-type');
      $('.accordion-cont:eq(-0)').addClass('last-of-type');
      $('.accordion-title').append('<i class="ci-arrow"></i>');/*<i class="fa fa-angle-down ci wf ts"></i>*/
      $('.accordion-cont').hide();
      $('.accordion-title').click(function () {
            var $accordionTitle = $(this);
            var $accordionContent = $(this).nextUntil(accortionTitleSelector+',hr');
            if ($accordionContent.is(':visible')) {
                $accordionContent.slideUp(delayOut, function () {
                    $accordionTitle.addClass('is-closed').removeClass('is-open');
                });
            } else {
                $accordionContent.slideDown(delayIn, function () {
                    $accordionTitle.addClass('is-open').removeClass('is-closed');
                });
            }
     });



    // navtoggle
    var openClass = 'is-open';
    var hoverClass = 'is-hover';
    var clickableClass = 'is-clickable';
    
    //var bodyOpenClass = 'has-header-navt-open';
    
    $(document).on('click','.navt-button',function(e) {
        if (!$(this).parent('.navt').hasClass(clickableClass)) {
            e.preventDefault();
        }
        var $navButton = $(this).not('.navt-button-fullwidth');
        var $nav = $navButton.parents('.navt');
        var $navContent = $navButton.next('.navt-content');

        if ($(this).hasClass('navt-button-fullwidth')) {
            var $navButtonFullwidth = $(this);
            var $navFullwidth = $navButtonFullwidth.parents('.navt-fullwidth');
            var navButtonTargetId = $navButtonFullwidth.attr('data-navt-button-target-id');
            var navContentFullwidthSelector = '.navt-content-fullwidth[data-navt-content-id="'+navButtonTargetId+'"]';
            var $navContentFullwidth = $(navContentFullwidthSelector);
        }
        
        if ($navContent.length) {
            
            //$('.navt-fullwidth').removeClass(openClass);
            //$('.navt-content-fullwidth').removeClass(openClass);

            if( $nav.hasClass(openClass) ) {
                $nav.not('.navt-no-dismiss').removeClass(openClass);
                //$('body').removeClass(bodyOpenClass);
            } else {
                //$('body').addClass(bodyOpenClass);
                $('.navt').not($nav).not('.navt-no-dismiss').removeClass(openClass);
                $nav.addClass(openClass);
                if ($nav.find('.trigger-input-focus').length) {
                    $('.trigger-input-focus').focus();
                }
            }
            
            // if ($('#nav .navt.is-open').length) {
            //     //console.log('true');
            //     $('body').addClass(bodyOpenClass);
            // } else {
            //     $('body').removeClass(bodyOpenClass);
            //     //console.log('false');
            // }

        } else if ($navContentFullwidth.length) {
            
            //$('.navt-fullwidth').removeClass(openClass);
            //$('.navt-content-fullwidth').removeClass(openClass);

            if ($navFullwidth.hasClass(openClass)) {
                $navFullwidth.removeClass(openClass);
                $navContentFullwidth.removeClass(openClass);
            } else {
                //$('.navt-fullwidth').not($navFullwidth).removeClass(openClass);
                $('.navt-fullwidth').not($navFullwidth).removeClass(openClass);
                $('.navt-content-fullwidth').not($navContentFullwidth).removeClass(openClass);
                $navFullwidth.addClass(openClass);
                $navContentFullwidth.addClass(openClass);
            }

        }

        
    });
    
    $(document).on('mouseup', document ,function(e) {
        var $nav = $('.navt').not('.navt-fullwidth').not('.navt-no-dismiss');
        // if the target of the click isn't the $navContent...
        // && ... nor a descendant of the $navContent
        if ( !$nav.is(e.target) && $nav.has(e.target).length === 0) {
            $nav.removeClass(openClass);
            //$('body').removeClass(bodyOpenClass);
        }

        var $navFullwidth = $('.navt-fullwidth, .navt-content-fullwidth').not('.navt-no-dismiss');
        // if the target of the click isn't the $navContent...
        // && ... nor a descendant of the $navContent
        if ( !$navFullwidth.is(e.target) && $navFullwidth.has(e.target).length === 0) {
            $navFullwidth.removeClass(openClass);
        }

    });
    
    // consente di chiudere il menu/tooltip nel caso di hover
    $(document).on('click','.navt.'+hoverClass+' .navt-content',function() {
        var $nav = $(this).parents('.navt');
        $nav.removeClass(hoverClass);
        setTimeout(function() {
            $nav.addClass(hoverClass);
        }, 1000);
    });
    
    $(document).on('click','.navt-dismiss',function() {
        $(this).parents('.navt').children('.navt-button').click();
    });

    $(document).on('click','.navt-fullwidth-dismiss',function() {
        var navButtonTargetId = $(this).parents('[data-navt-content-id]').attr('data-navt-content-id');
        $('.navt-button-fullwidth[data-navt-button-target-id="'+navButtonTargetId+'"]').click();
    });



    // blulab, individua parametri url
    // utile per impostare link scroll anchor quando non è possibile usare il semplice id, 
    // perché i prodotti shopify con varianti fanno redirect e spostano l'id dopo i parametri
    // get url parameters
    function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) 
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) 
            {
                return sParameterName[1];
            }
        };
    };

    // blulab, imposta scroll tramite parametro &section=nome-dell-id

    $(window).on('load', function() {

        var sectionAnchor = GetURLParameter('section');

        if (typeof sectionAnchor !== 'undefined') {

            var sectionAnchorSelector = '#'+sectionAnchor;

            if ($(sectionAnchorSelector).length) {
                var topValue = parseInt($(sectionAnchorSelector).offset().top);

                if (typeof topValue !== 'undefined' && topValue > 0) {
                    window.scrollTo({
                        top: topValue,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            }
        }

    });




    $(document).on('click', '.js-trigger-nav-footer-lang', function(e) {
        e.preventDefault();
        var langISO = $(this).attr('lang');
        console.log('langISO lang', langISO);
        $('.site-footer input[name="locale_code"]').val(langISO).parents('form').submit();
    });

    
    
});
